<span class="d-block" >{{ step2.getspan4  | translate }}</span>

<!-- <app-type-lieu *ngIf="!cbChecked()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_221'}"
[lieuExecutionLivraison]="descriptionReduite?.lieuExecution"></app-type-lieu> -->

<!-- <span class="d-block" *ngIf="!cbChecked()">{{ step2.getspan5  | translate }}</span> -->

<!-- <app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="annulation?.lieuExecutionLivraison"
[label]="step2.getlieuexecutionlivraison"
[checkboxDestination]="'object'"
[type]="'checkbox'" [rule]="''"
[name]="getUid()+'_SepAtt_lieuExecutionCB'">
</app-form-input> -->

<!-- <app-type-lieu *ngIf="!cbChecked()"  [uid]="'lieuLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_175', 'pattern' : 'ctr_222'}"
 [lieuExecutionLivraison]="annulation?.lieuLivraison"></app-type-lieu> -->

<!-- <app-type-lieu *ngIf="cbChecked()" [uid]="'lieuExecutionLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_43'}"
 [lieuExecutionLivraison]="descriptionReduite?.lieuExecutionLivraison"></app-type-lieu> -->








<!-- <app-type-lieu [parentForm]="parentForm" 
[typeLieu]="descriptionReduite.lieuExecution" 
[uid]="getUid()"></app-type-lieu> -->